import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-900 text-white px-3 py-2 border border-[#FF5A00] font-mono-data text-xs">
      <div className="opacity-60">{label}</div>
      <div className="text-[#FF5A00] font-bold text-sm">
        ₹{payload[0].value.toFixed(2)}
      </div>
    </div>
  );
};

export default function PriceTrendChart({ data, height = 220 }) {
  const values = data.map((d) => d.price);
  const min = Math.floor(Math.min(...values) * 0.98);
  const max = Math.ceil(Math.max(...values) * 1.02);

  return (
    <div data-testid="price-trend-chart" className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
          <defs>
            <linearGradient id="rk-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FF5A00" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#FF5A00" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#e4e4e7" strokeDasharray="2 2" vertical={false} />
          <XAxis
            dataKey="date"
            tick={{ fontFamily: "IBM Plex Mono", fontSize: 10, fill: "#71717a" }}
            tickLine={false}
            axisLine={{ stroke: "#09090b" }}
            interval={Math.floor(data.length / 6)}
          />
          <YAxis
            domain={[min, max]}
            tick={{ fontFamily: "IBM Plex Mono", fontSize: 10, fill: "#71717a" }}
            tickLine={false}
            axisLine={{ stroke: "#09090b" }}
            tickFormatter={(v) => `₹${v}`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="price"
            stroke="#FF5A00"
            strokeWidth={2}
            fill="url(#rk-grad)"
            dot={false}
            activeDot={{ r: 4, fill: "#FF5A00", stroke: "#09090b", strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
